export default __webpack_public_path__ + "static/media/Peppe Voltarelli.2910381a.jpg";